define('modules/editor/views/editors/seo',['require','exports','module','common/views/modal_layout','./seo_custom_meta','ldsh!../../templates/editors/seo'],function (require, exports, module) {
  'use strict';
  var BaseView = require('common/views/modal_layout'),
    CustomMeta = require('./seo_custom_meta');

  module.exports = BaseView.extend({
    template: require('ldsh!../../templates/editors/seo'),

    regions: {
      customMeta: '.custom-meta',
    },

    events: {
      'click .js-save': 'save',
      'click .js-help-icon': 'toggleHelp',
      'submit form': 'save',
    },

    initialize: function (options) {
      var customMetaCollectionView = new CustomMeta({ collection: this.model.customMeta });
      this.regions.customMeta.show(customMetaCollectionView);
    },

    helpers: function () {
      var robots = this.model.get('robots').split(', '),
        canonicalEnabled = this.model.get('canonicalEnabled') || 'false',
        canonicalURL = this.model.get('canonicalURL') || '';

      return {
        robotIndex: robots[0] || 'index',
        robotFollow: robots[1] || 'follow',
        canonicalEnabled: canonicalEnabled,
        canonicalURL: canonicalURL,
      };
    },

    save: function (e) {
      e.preventDefault();
      this._saveData();
      this.trigger('modal:save', this.model);
    },

    _saveData: function () {
      var title = this.$('input[name=title]').val(),
        description = this.$('textarea[name=description]').val(),
        keywords = this.$('textarea[name=keywords]').val(),
        robotIndex = this.$('input[name=index]:checked').val(),
        robotFollow = this.$('input[name=follow]:checked').val(),
        canonicalEnabled = this.$('input[name=canonical]:checked').val() || 'false',
        canonicalURL = this.$('input[name=canonicalURL]').val();

      var dataToSave = {
        title: title,
        description: description,
        keywords: keywords,
        robots: robotIndex + ', ' + robotFollow,
        canonicalEnabled: canonicalEnabled,
        canonicalURL: canonicalURL,
      };

      this.model.set(dataToSave);
    },

    toggleHelp: function (e) {
      const currentTooltip = $(e.currentTarget).next('.js-help');

      $('.js-help').not(currentTooltip).hide();
      currentTooltip.toggle();
    },

    onRender: function () {
      this.$el.i18n();
    },
  });
});

